import { GlassCard } from "./GlassCard";
import { SignalPill } from "./SignalPill";

interface SignalStripItem {
  label: string;
  value: string;
  note?: string;
  tone?: "positive" | "warning" | "neutral";
}

interface SignalStripProps {
  items: SignalStripItem[];
}

export function SignalStrip({ items }: SignalStripProps) {
  return (
    <div className="signal-strip-grid">
      {items.map((item) => (
        <GlassCard key={item.label} className="signal-strip-card stack-xs">
          <div className="row-between signal-strip-header">
            <span className="card-eyebrow">{item.label}</span>
            {item.tone ? <SignalPill label={item.tone === "positive" ? "Supportive" : item.tone === "warning" ? "Open" : "Live"} tone={item.tone} /> : null}
          </div>
          <div className="signal-strip-value">{item.value}</div>
          {item.note ? <p className="signal-strip-note">{item.note}</p> : null}
        </GlassCard>
      ))}
    </div>
  );
}
